module.exports = __webpack_public_path__ + "img/Redemption-customhouse.62e66aa8.webp";